export const APP_PATH = {
	//not found
	notFound: "/not-found",

	//dashboard
	dashboard: "/dashboard",

	//my-account
	myAccount: "/my-account",

	// staffs
	staffs: "/staffs-list",
	staffCreate: "/staffs-list/create",
	staffDecentralization: "/staffs-decentralization",
	staffRoles: "/staffs-roles",
	staffRolesCreate: "/staffs-roles/create",
	// Sale staffs
	saleStaffs: "/staffs-sales",
	saleStaffCreate: "/staffs-sales/create",
	// CRM
	merchants: "/crm/merchants/merchants",
	merchantCreate: "/crm/merchants/merchants/create",
	cars: "/crm/merchants/cars",
	carCreate: "/crm/merchants/cars/create",
	carParts: "/crm/merchants/car-parts",
	supercars: "/crm/merchants/supercars",
	supercarCreate: "/crm/merchants/supercars/create",
	customers: "/crm/customers",
	customerCreate: "/crm/customers/create",
	carStore: "crm/merchants/stores",
	carCares: "/crm/merchants/car-cares",
	stores: "/crm/merchants/car-stores",
	storesCreate: "/crm/merchants/car-stores/create",

	// master data
	showrooms: "/master-data/showrooms",
	showroomCreate: "/master-data/showrooms/create",
	brands: "/master-data/brands",
	brandCreate: "/master-data/brands/create",
	models: "/master-data/models",
	modelCreate: "/master-data/models/create",
	categories: "/master-data/categories",
	categoriesCreate: "/master-data/categories/create",
	partTypes: "/master-data/part-types",
	partType: "/master-data/part-types/:id",
	partTypeCreate: "/master-data/part-types/create",
	carCareCategories: "/master-data/car-care-categories",
	carCareCategory: "/master-data/car-care-categories/:id",
	carCareCategoryCreate: "/master-data/car-care-categories/create",
	partners: "/master-data/partners",
	partner: "/master-data/partners/:id",
	partnerCreate: "/master-data/partners/create",
	productSupportTypes: "/master-data/product-support-types",
	productSupportTypeCreate: "/master-data/product-support-types/0",
	productSupportTypeUpdate: "/master-data/product-support-types/:id",
	rescueStores: "/master-data/rescue-stores",
	rescueStoreCreate: "/master-data/rescue-stores/0",
	rescueStoreUpdate: "/master-data/rescue-stores/:id",

	// config
	banners: "/config/banner/banners",
	bannerCreate: "/config/banner/banners/create",
	bannersAds: "/config/banner/banner-ads",
	bannersAdCreate: "/config/banner/banner-ads/create",

	bannerConfig: "/config/banner",
	appHorizontalBanners: "/config/banner/app/horizontal-banners",
	appHorizontalBannerCreate: "/config/banner/app/horizontal-banners/create",
	appVerticleBanner: "/config/banner/app/verticle-banners",
	webappHorizontalBanners: "/config/banner/banner-webapp/horizontal-banner",
	webappHorizontalBannerCreate:
		"/config/banner/banner-webapp/horizontal-banner/create",
	webappVerticalBanners: "/config/banner/banner-webapp/vertical-banner",
	webappVerticalBannerCreate:
		"/config/banner/banner-webapp/vertical-banner/create",

	popups: "/config/popups",
	popupCreate: "/config/popups/create",
	news: "/config/news",
	newsCreate: "/config/news/create",
	hotSale: "/config/hot-sale",

	//transaction
	transactionAppointment: "/transaction-appointment",
	transactionService: "/transaction-service",
	transactionPurchase: "/transaction-purchase",
	transactionCarCare: "/transaction-car-care",
	transactionReconciliation: "/transaction-reconciliation",
	transactionBillingInfor: "/transaction-billing-infor",
	transactionCarAccessoryOrders: "/transaction-car-accessory-orders",
	// notifications
	announcements: "/notifications/announcements",
	announcementCreate: "/notifications/announcements/create",
	notifications: "/notifications/systems",
	notificationCreate: "/notifications/systems/create",

	// service
	services: "/services/services",
	serviceCreate: "/services/services/create",
	serviceCategories: "/services/service-categories",
	serviceCategoryCreate: "/services/service-categories/create",

	//Survey answer
	surveyAnswer: "/survey-answers",

	//App version
	appVersion: "/app-version",

	// affitiate
	affiliateTransactions: "/affiliate/transactions",
	affiliateTransaction: "/affiliate/transactions/:id",
	collaborators: "/affiliate/collaborators",
	collaborator: "/affiliate/collaborator",

	affiliatePayment: "/affiliate/payment",

	commissionPolicies: "/affiliate/commission-policies",
	commissionPolicyCreate: "/affiliate/commission-policies/create",

	conversions: "/affiliate/conversions",

	// community
	// post
	communityPosts: "/community/posts",
	communityPost: "/community/posts/:id",
	communityPostCreate: "/community/posts/create",

	// loyalty
	// loyalty-campaign
	loyaltyCampaigns: "/loyalty/campaigns",
	loyaltyCampaignCreate: "/loyalty/campaigns/create",

	// loyalty-voucher

	loyaltyCustomerVouchersOfLiberty:
		"/loyalty/vouchers/customer/vouchers-of-liberty",
	loyaltyCustomerVoucherOfLibertyCreate:
		"/loyalty/vouchers/customer/vouchers-of-liberty/create",

	loyaltyCustomerVouchersOfMerchant:
		"/loyalty/vouchers/customer/vouchers-of-merchant",

	loyaltyVouchersMerchant: "/loyalty/vouchers/merchant",
	loyaltyVoucherMerchantCreate: "/loyalty/vouchers/merchant/create",

	// Rating
	ratingContent: "/ratings/contents",
	ratingContentDetail: "/ratings/contents/:id",
	merchantRatings: "/ratings/merchant",
	customerRatings: "/ratings/customer",

	// Form-request
	investment: "/webapp/investment",
	recruitmentCareerPosts: "/webapp/recruitment/posts",
	recruitmentCareerPostsCreate: "/webapp/recruitment/posts/create",
	recruitmentCandidates: "/webapp/recruitment/candidates",

	// Auction
	auctions: "/auctions",
	auctionCreate: "/auctions/create",
	// Subscription
	subscriptionClass: "/config/subscription-package",
	subscriptionClassCreate: "/config/subscription-package/create",
	survey: "/survey",
	surveyDetail: "/survey/detail",

	// request services
	contactSupports: "/request-services/contact-supports",
	contactSupport: "/request-services/contact-supports/:id",
	transactionMerchantRequest: "/request-services/transaction-merchant-request",
	formRequest: "/request-services/form-request",

	// Investment
	investments: "/investments",
	investmentDetail: "/investments/:id",
	investmentCreate: "/investments/create",

	// Loan Application
	loanApplications: "/loan-applications",
	loanApplicationDetail: "/loan-applications/:id",
};
